<script>
    import ItemPlayer from './ItemPlayer.svelte';
    import { db } from './firebase';
    export let status;
    let tracks=[];
    const tracksRef = db.collection("tracks");

    tracksRef.where("status", "==", status)
    .onSnapshot(function(querySnapshot) {
        tracks = [];
        querySnapshot.forEach(function(doc) {
            console.log('doc data:',doc.data());
            tracks = [...tracks, doc.data()];
        });
        console.log("tracks: ", tracks);
    });

    function activateTrack (trackId){
        console.log('activate trackId: ', trackId);
        tracksRef.doc(trackId).set({
            status: 'active'
        }, { merge: true });
    }

    function deleteTrack (trackId){
        console.log('delete trackId: ', trackId);
        tracksRef.doc(trackId).delete().then(function() {
            console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
    }
</script>

<div id="container">
    {#each tracks as track}
        <div class="track-container">
            <button on:click={() => deleteTrack(track.id)}>
                -
            </button>
            <ItemPlayer {...track} />
            {#if status === 'pending'}
                <button on:click={() => activateTrack(track.id)}>
                    ✓
                </button>
            {/if}
        </div>
    {/each}
</div>

<style>
    #container {
        display: inline-block;
        max-width: 500px;
        width: 100%;
    }
    button {
        cursor: pointer;
        width: 40px;
        height: 40px;
    }
    .track-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>

